module.exports = __webpack_public_path__ + "static/media/can-send.6f0618d8.svg";